/**
 * Columbia Hike Society page interactions.
 * - Month filter buttons (Todos + configurable month blocks)
 * - Horizontal card slider with arrow navigation
 */
(function () {
  'use strict';

  function initSection(root) {
    if (!root || root.dataset.hsInitialized === 'true') return;
    root.dataset.hsInitialized = 'true';

    var filterButtons = root.querySelectorAll('[data-hs-filter]');
    var yearTabButtons = root.querySelectorAll('[data-hs-year-tab]');
    var yearPanels = root.querySelectorAll('[data-hs-year-panel]');
    var cards = root.querySelectorAll('[data-hs-card]');
    var track = root.querySelector('[data-hs-slider-track]');
    var trackContainer = root.querySelector(
      '.columbiape-store-theme-8-x-sliderTrackContainer'
    );
    var prevBtn = root.querySelector('[data-hs-slider-prev]');
    var nextBtn = root.querySelector('[data-hs-slider-next]');
    var slideIndex = 0;
    var activeYear =
      yearTabButtons.length > 0 ? yearTabButtons[0].dataset.hsYearTab : '';

    function getVisibleSlides() {
      return Array.prototype.filter.call(
        root.querySelectorAll('.columbiape-store-theme-8-x-slide'),
        function (slide) {
          return !slide.classList.contains('is-hidden');
        }
      );
    }

    function getSlidesPerView() {
      if (window.innerWidth <= 768) return 1;
      if (window.innerWidth <= 1024) return 2;
      return 4;
    }

    function getSlideStepPx() {
      if (!trackContainer) return 0;
      return trackContainer.getBoundingClientRect().width / getSlidesPerView();
    }

    function applyFilter(filter, year) {
      cards.forEach(function (card) {
        var month = card.dataset.hsMonth || '';
        var cardYear = card.dataset.hsYear || '';
        var monthMatch =
          filter === 'todos' || month === filter || month === 'all';
        var yearMatch = !year || cardYear === year || cardYear === '';
        var show = monthMatch && yearMatch;
        card.classList.toggle('is-hidden', !show);
        var slide = card.closest('.columbiape-store-theme-8-x-slide');
        if (slide) slide.classList.toggle('is-hidden', !show);
      });

      filterButtons.forEach(function (btn) {
        var btnYear = btn.dataset.hsYear || '';
        var isActive =
          btn.dataset.hsFilter === filter && btnYear === (year || '');
        btn.classList.toggle(
          'columbiape-store-theme-8-x-hikeSocietyEvents__filterButton_active',
          isActive
        );
        btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      slideIndex = 0;
      updateSlider();
    }

    function activateYear(year) {
      activeYear = year;

      yearTabButtons.forEach(function (btn) {
        var isActive = btn.dataset.hsYearTab === year;
        btn.classList.toggle(
          'columbiape-store-theme-8-x-hikeSocietyEvents__yearButton_active',
          isActive
        );
        btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      yearPanels.forEach(function (panel) {
        panel.classList.toggle(
          'is-hidden',
          panel.dataset.hsYearPanel !== year
        );
      });

      applyFilter('todos', year);
    }

    function updateSlider() {
      if (!track || !trackContainer) return;

      var visible = getVisibleSlides();
      var perView = getSlidesPerView();
      var maxIndex = Math.max(0, visible.length - perView);

      if (slideIndex > maxIndex) slideIndex = maxIndex;
      if (slideIndex < 0) slideIndex = 0;

      var offset = slideIndex * getSlideStepPx();
      track.style.transform = 'translate3d(-' + offset + 'px, 0, 0)';

      if (prevBtn) {
        prevBtn.disabled = slideIndex <= 0;
        prevBtn.style.visibility = slideIndex <= 0 ? 'hidden' : 'visible';
      }
      if (nextBtn) {
        nextBtn.disabled = slideIndex >= maxIndex;
        nextBtn.style.visibility =
          slideIndex >= maxIndex ? 'hidden' : 'visible';
      }
    }

    filterButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        applyFilter(btn.dataset.hsFilter, btn.dataset.hsYear || '');
      });
    });

    yearTabButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        activateYear(btn.dataset.hsYearTab);
      });
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        slideIndex -= 1;
        updateSlider();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        slideIndex += 1;
        updateSlider();
      });
    }

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(updateSlider, 150);
    });

    applyFilter('todos', activeYear);
  }

  function initAll() {
    document
      .querySelectorAll('[data-hike-society-section]')
      .forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-hike-society-section]');
    if (section) initSection(section);
  });
})();
